import React from "react";
import classNames from "classnames";
import { Field } from "@design-system/Field/Field";
import { TextArea } from "@design-system/TextArea/TextArea";
import { useNativeInvoiceFormContext } from "./NativeInvoiceFormContext";
import { resetCollapsedTextAreaScroll } from "./resetCollapsedTextAreaScroll";
import styles from "./SidePanel.module.scss";

export const NativeInvoiceFooterField: React.FC = () => {
    const { state, setState } = useNativeInvoiceFormContext();

    return (
        <Field label="Footer">
            <TextArea
                size="xl"
                className={classNames(
                    styles.collapsibleTextarea,
                    styles.collapsibleTextareaStatic,
                )}
                maxLength={2000}
                onBlur={resetCollapsedTextAreaScroll}
                value={state.footer}
                onChange={(event) =>
                    setState((prev) => ({
                        ...prev,
                        footer: event.target.value,
                    }))
                }
            />
        </Field>
    );
};
